import * as axios from 'axios';


function getOverview(uid) { 

    const data = {  }

    const url = `/inspect/overview`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}



export { getOverview }